<template>
    <section id="mainContainer">
        <adminHeader></adminHeader>
        <section class="admin-mid-container">
            <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
                <adminNavigation></adminNavigation>
                <section class="admin-right-sidebar">
                    <div class="admin-right-sidebar-in">
                        <div class="admin-right-sidebar-in-top">
                            <div class="admin-custom-row">
                                <div class="admin-right-sidebar-in-top-left">
                                    <h1>
                                        {{ constants.MANAGE_BLOGS_TEXT }}
                                    </h1>
                                    <div class="admin-page-type-links">
                                        <ul>
                                            <li>
                                                <a id="allLink" href="#" :class="{ active: activeTab === 'all' }" @click="switchView('all')">
                                                    {{ constants.ALL_LINK }}
                                                    <span>{{ counts.all }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="publishedhLink" href="#" :class="{ active: activeTab === 'published' }" @click="switchView('published')">
                                                    {{ constants.PUBLISHED_LINK }}
                                                    <span>{{ counts.published }}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="unPublishedhLink" href="#" :class="{ active: activeTab === 'unpublished' }" @click="switchView('unpublished')">
                                                    {{ constants.UNPUBLISHED_LINK }}
                                                    <span>{{ counts.unpublished }}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="admin-right-sidebar-in-top-right">
                                    <div class="admin-right-sidebar-in-top-right-top">
                                        <div class="admin-search-box">
                                            <input id="seachBlogInput" type="text" placeholder="Search" v-model="searchedText" @keyup.enter="fetchBlogs(activeTab), fetchCounts(searchedText)" />
                                        </div>
                                        <div class="admin-add-btn">
                                            <button id="addBlogBtn" class="add-btn-admin" :class="{ 'active': showAddForm }" @click="openAddBlogForm">
                                                <i class="add-icon"></i>
                                                {{ constants.ADD_BLOG_BUTTON }}
                                            </button>
                                        </div>
                                        <div class="admin-add-btn">
                                            <a class="add-btn-admin" id="addBlogCategoryLink" href="/authority/blog-category">
                                                <i class="add-icon"></i>
                                                {{ constants.ADD_BLOG_CATEGORY_BUTTON }}
                                            </a>
                                        </div>
                                    </div>
                                    <div class="admin-right-sidebar-in-top-right-btm" v-if="selectedBlogs.length > 1">
                                        <div class="tags">
                                            <ul>
                                                <li>
                                                    <span>{{ selectedBlogs.length }} entries selected</span>
                                                    <button id="tagCloseBtn" @click="selectedBlogs = [], selectAll = false"></button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="delete-all-btn-link">
                                            <button class="btn_link" id="deleteAllBtn" data-bs-toggle="modal" data-bs-target="#deletePop" @click="setDeleteMode('all')">{{ constants.DELETE_ALL_BUTTON }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="showAddForm" class="white-bg-border add-new-section">
                            <div class="add-banner-image-section">
                                <h2>
                                    {{ constants.ADD_NEW_BLOG_TEXT }}
                                </h2>
                                <div class="add-banner-image-box">
                                    <form id="addBlogForm" @submit.prevent="submitForm">
                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.JOB_BLOG_LABEL }}
                                            </label>
                                            <input id="blogTitleInput" type="text" placeholder="Enter the Title" v-model="newBlog.title" @input="updateNewBlogSlug" />
                                            <div class="error-msg" v-if="!newBlog.title">{{ errMsg }}</div>
                                        </div>

                                        <div class="admin-input-field">
                                            <label>
                                                URL Slug
                                            </label>
                                            <div class="slug-input-wrapper">
                                                <input id="blogSlugInput" type="text" placeholder="Enter the URL Slug" v-model="newBlog.slug" :disabled="!isNewSlugEditable" />
                                                <button type="button" class="edit-slug-btn" @click="toggleNewSlugEdit">{{ isNewSlugEditable ? 'Save' : 'Edit' }}</button>
                                            </div>
                                            <div class="error-msg" v-if="!newBlog.slug">{{ errMsg }}</div>
                                        </div>

                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.BLOG_CATEGORY_LABEL }}
                                            </label>
                                            <select class="admin-selectbox" id="blogCategorySelectBox" v-model="newBlog.blogCategory">
                                                <option value="">Select the blog category</option>
                                                <option v-for="category in blogCategories" :key="category.id" :value="category.title">
                                                    {{ category.title }}
                                                </option>
                                            </select>
                                            <div class="error-msg" v-if="!newBlog.blogCategory">{{ errMsg }}</div>
                                        </div>

                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.AUTHOR_LABEL }}
                                            </label>
                                            <input id="authorInput" type="text" placeholder="Enter the Author" v-model="newBlog.author" />
                                            <div class="error-msg" v-if="!newBlog.author">{{ errMsg }}</div>
                                        </div>

                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.LOCATION_LABEL }}
                                            </label>
                                            <input type="text" id="locationInput" placeholder="Enter the location" v-model="newBlog.location" />
                                            <div class="error-msg" v-if="!newBlog.location">{{ errMsg }}</div>
                                        </div>

                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.DATE_LABEL }}
                                            </label>
                                            <div class="admin-date-input">
                                                <datepicker 
                                                 v-model="newBlog.blogPostDate" id="dateInput" class="date-icon" placeholder="Enter Date">
                                                </datepicker>
                                            </div>
                                            <div class="error-msg" v-if="!newBlog.blogPostDate">{{ errMsg }}</div>
                                        </div>

                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.BLOG_DESCRIPTION_LABEL }}
                                            </label>
                                            <ckeditor placeholder="Blog Description" class="text-editer" id="blogDescriptionInput" :editor="editor" v-model="newBlog.description" :config="Config"></ckeditor>
                                            <div class="error-msg" v-if="!newBlog.description">{{ errMsg }}</div>
                                        </div>

                                        <div class="admin-input-field">
                                            <label>
                                                {{ constants.IMAGE_LABEL }}
                                            </label>
                                            <div class="image-upload-input upload-banner-image">
                                                <div :class="['image-upload-input-item', { 'uploaded-done': imageUploaded }]">
                                                    <div class="file-input-box">
                                                        <input type="file" id="blogFileInput" @change="handleFileUpload($event, false)" accept="image/jpeg,image/jpg,image/png" />
                                                    </div>
                                                    <div class="image-upload-input-item-in" v-if="!imageUploaded">
                                                        <div class="image-upload-input-item-icon">
                                                            <img src="@/assets/images/admin-img/image-icon.svg" alt="" />
                                                        </div>
                                                        <span>
                                                            {{ constants.ADD_IMAGE_LABEL }}
                                                        </span>
                                                    </div>
                                                    <div class="image-upload-input-item-uploaded" v-if="imageUploaded">
                                                        <img :src="imageUrl" alt="" class="mCS_img_loaded">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="error-msg" v-if="!selectedFile">{{ errMsg }}</div>
                                        </div>

                                        <div class="admin-input-field-submit">
                                            <button class="admin-btn-outline-primary add-new-cancel" id="submitBtn" type="submit" :disabled="isSubmitting">
                                                {{ constants.SUBMIT_BUTTON }}
                                            </button>
                                            <button class="admin-btn-outline-secondary add-new-cancel" id="cancelBtn" type="button" @click="cancelForm">
                                                {{ constants.CANCEL_BUTTON }}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div :class="['admin-item-list-section admin-blogs-section', { 'show-edit-item-outer': editFormSubmitted }]" v-if="editBlogsData.length > 0">
                            <div class="admin-item-list-section-in" ref="scrollWrapper" data-simplebar>
                                <div class="admin-item-list-section-scroll">
                                    <div class="admin-item-list-top">
                                        <div class="admin-item-list-row">
                                            <div class="admin-item-checkbox">
                                                <div class="admin-checkbox-input">
                                                    <input name="cssCheckbox" id="selectAll" type="checkbox" class="css-checkbox" @change="toggleSelectAll" :checked="selectAll === true">
                                                    <label for="selectAll"></label>
                                                </div>
                                            </div>

                                            <div class="admin-item-image">
                                                {{ constants.IMAGE_LABEL }}
                                            </div>

                                            <div class="admin-item-blogs-title">
                                                {{ constants.TITLE_LABEL }}
                                            </div>

                                            <div class="admin-item-blogs-category">
                                                {{ constants.BLOG_CATEGORY_LABEL }}
                                            </div>

                                            <div class="admin-item-blogs-author">
                                                {{ constants.AUTHOR_LABEL }}
                                            </div>

                                            <div class="admin-item-blogs-location">
                                                {{ constants.LOCATION_LABEL }}
                                            </div>
                                            <div class="admin-item-blogs-desc">
                                                {{ constants.BLOG_DESCRIPTION_LABEL }}
                                            </div>

                                            <div class="admin-item-blogs-date">
                                                {{ constants.DATE_LABEL }}
                                            </div>
                                            <div class="admin-item-actions">
                                                {{ constants.ACTIONS_LABEL }}
                                            </div>
                                            <div class="clear"></div>
                                        </div>
                                    </div>
                                    <div class="admin-item-list-btm">
                                        <div ref="sortableList">
                                            <div v-for="(blog, index) in editBlogsData" :key="blog.id" :class="['admin-item-box', { 'show-edit-item': editFormSubmitted }]">
                                                <div class="admin-item-box-top">
                                                    <div class="admin-item-list-row">
                                                        <div class="admin-item-checkbox">
                                                            <div class="admin-checkbox-input">
                                                                <input name="cssCheckbox" :id="'demo_opt_' + blog.id" type="checkbox" class="css-checkbox" @change="toggleBlogSelection(blog.slug)" :checked="selectedBlogs.includes(blog.slug)">
                                                                <label :for="'demo_opt_' + blog.id"></label>
                                                            </div>
                                                        </div>

                                                        <div class="admin-item-image">
                                                            <div class="sm-img"><img :src="getCdnImageAddress(blog.blogImage, `w_31,h_31/`)" alt="" /></div>
                                                        </div>

                                                        <div class="admin-item-blogs-title text-limit">
                                                            {{ blog.title }}
                                                        </div>

                                                        <div class="admin-item-blogs-category text-limit">
                                                            {{ blog.blogCategory }}
                                                        </div>

                                                        <div class="admin-item-blogs-author text-limit">
                                                            {{ blog.author }}
                                                        </div>

                                                        <div class="admin-item-blogs-location text-limit">
                                                            {{ blog.location }}
                                                        </div>

                                                        <div class="admin-item-blogs-desc text-limit">
                                                            {{ useStripHtml(blog.description) }}
                                                        </div>

                                                        <div class="admin-item-blogs-date">
                                                            <span v-b-tooltip.right :title="formatDate(blog.blogPostDate)" data-bs-toggle="tooltip">{{ formatDate(blog.blogPostDate) }}</span>
                                                        </div>

                                                        <div class="admin-item-actions">
                                                            <ul class="admin-action-link">
                                                                <li>
                                                                    <button id="blogPgEditBtn" class="editBtn" @click="editBlog(index), showAddForm = false">{{ constants.EDIT_BUTTON }}</button>
                                                                </li>
                                                                <li>
                                                                    <button id="blogPgDeleteBtn" data-bs-toggle="modal" data-bs-target="#deletePop" @click="setDeleteMode('single', blog.slug), showAddForm = false, cancelEdit()">
                                                                        {{ constants.DELETE_BUTTON }}
                                                                    </button>
                                                                </li>

                                                                <li>
                                                                    <button id="blogPgUnPublishBtn" class="primary-outline-btn" v-if="blog.status === 1" @click="changeBlogStatus(blog.slug, 0)">
                                                                        {{ constants.UNPUBLISH_BUTTON }}
                                                                    </button>
                                                                    <button id="blogPgPublishBtn" class="primary-outline-btn" v-else-if="blog.status === 0" @click="changeBlogStatus(blog.slug, 1)">
                                                                        {{ constants.PUBLISH_BUTTON }}
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="admin-item-box-btm" v-if="blog.editing">
                                                    <div class="add-banner-image-section">
                                                        <h2>
                                                            {{ constants.EDIT_BLOG_TEXT }}
                                                        </h2>
                                                        <div class="add-banner-image-box">
                                                            <div class="admin-input-field">
                                                                <label>
                                                                    {{ constants.JOB_BLOG_LABEL }}
                                                                </label>
                                                                <input id="blogTitleInput" type="text" placeholder="Enter the Title" v-model="editBlogData.title" @input="updateEditBlogSlug" />
                                                                <div class="error-msg" v-if="!editBlogData.title">{{ errEditMsg }}</div>
                                                            </div>

                                                            <div class="admin-input-field">
                                                                <label>
                                                                    URL Slug
                                                                </label>
                                                                <div class="slug-input-wrapper">
                                                                    <input id="blogEditSlugInput" type="text" placeholder="Enter the URL Slug" v-model="editBlogData.slug" :disabled="!isEditSlugEditable" />
                                                                    <button type="button" class="edit-slug-btn" @click="toggleEditSlugEdit">{{ isEditSlugEditable ? 'Save' : 'Edit' }}</button>
                                                                </div>
                                                                <div class="error-msg" v-if="!editBlogData.slug">{{ errEditMsg }}</div>
                                                            </div>

                                                            <div class="admin-input-field">
                                                                <label>
                                                                    {{ constants.BLOG_CATEGORY_LABEL }}
                                                                </label>
                                                                <select class="admin-selectbox" id="blogCategorySelectBox" v-model="editBlogData.blogCategory">
                                                                    <option value="">Select the blog category</option>
                                                                    <option v-for="category in blogCategories" :key="category.id" :value="category.title">
                                                                        {{ category.title }}
                                                                    </option>
                                                                </select>
                                                                <div class="error-msg" v-if="!editBlogData.blogCategory">{{ errEditMsg }}</div>
                                                            </div>

                                                            <div class="admin-input-field">
                                                                <label>
                                                                    {{ constants.AUTHOR_LABEL }}
                                                                </label>
                                                                <input id="authorInput" type="text" placeholder="Enter the Author" v-model="editBlogData.author" />
                                                                <div class="error-msg" v-if="!editBlogData.author">{{ errEditMsg }}</div>
                                                            </div>

                                                            <div class="admin-input-field">
                                                                <label>
                                                                    {{ constants.LOCATION_LABEL }}
                                                                </label>
                                                                <input type="text" id="locationInput" placeholder="Enter the location" v-model="editBlogData.location" />
                                                                <div class="error-msg" v-if="!editBlogData.location">{{ errEditMsg }}</div>
                                                            </div>

                                                            <div class="admin-input-field">
                                                                <label>
                                                                    {{ constants.DATE_LABEL }}
                                                                </label>
                                                                <div class="admin-date-input">
                                                                    <datepicker 
                                                                     v-model="editBlogData.blogPostDate" id="dateInput" class="date-icon" placeholder="Enter Date">
                                                                    </datepicker>
                                                                </div>
                                                                <div class="error-msg" v-if="!editBlogData.blogPostDate">{{ errEditMsg }}</div>
                                                            </div>

                                                            <div class="admin-input-field">
                                                                <label>
                                                                    {{ constants.BLOG_DESCRIPTION_LABEL }}
                                                                </label>
                                                                <ckeditor placeholder="Description" id="blogDescriptionInput" class="text-editer" :editor="editor" v-model="editBlogData.description" :config="Config">
                                                                </ckeditor>
                                                                <div class="error-msg" v-if="!editBlogData.description">{{ errEditMsg }}</div>
                                                            </div>

                                                            <div class="admin-input-field">
                                                                <label>
                                                                    {{ constants.IMAGE_LABEL }}
                                                                </label>
                                                                <div class="image-upload-input upload-banner-image">
                                                                    <div class="image-upload-input-item uploaded-done">
                                                                        <div class="file-input-box">
                                                                            <input type="file" id="blogFileInput" @change="handleFileUpload($event, true)" accept="image/jpeg,image/jpg,image/png" />
                                                                        </div>
                                                                        <div class="image-upload-input-item-uploaded">
                                                                            <img :src="editimageSrc || require('@/assets/images/admin-img/image-icon.svg')" alt="" />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="error-msg" v-if="!editBlogData.blogImage && !selectedEditFile">{{ errEditMsg }}</div>
                                                            </div>

                                                            <div class="admin-input-field-submit">
                                                                <button class="admin-btn-outline-primary addNewCancel" id="submitBtn" @click="submitEditForm()" :disabled="isSubmitting">
                                                                    {{  constants.SUBMIT_BUTTON }}
                                                                </button>
                                                                <button class="admin-btn-outline-secondary addNewCancel" id="cancelBtn" @click="cancelEdit">
                                                                    {{ constants.CANCEL_BUTTON }}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="admin-pagination-section">
                                <div class="custom-row">
                                    <div class="item-show-selectbox">
                                        <select id="paginationSelectBox" v-model="limit" @change="handleLimitChange">
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                        <span> {{ constants.ENTRIES_PER_PAGE_LABEL }}</span>
                                    </div>
                                    <div class="admin-pagination" id="paginationBox" v-if="totalPages > 1">
                                        <ul>
                                            <li v-if="currentPage !== 1" @click="changePage(currentPage - 1)">
                                                <a href="#" class="pagination-previous"></a>
                                            </li>
                                            <li v-for="page in visiblePages" :key="page" @click="changePage(page)" v-if="totalPages != 1">
                                                <a href="#" :class="{ active: currentPage === page }">{{ page }}</a>
                                            </li>
                                            <li v-if="currentPage !== totalPages" @click="changePage(currentPage + 1)">
                                                <a href="#" class="pagination-next"></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <p>No data to display</p>
                        </div>
                    </div>
                </section>
            </div>
        </section>
        <footer class="admin-site-footer">
            <div class="container">
                {{ constants.COPYRIGHT_TEXT }}
            </div>
        </footer>
        <div class="modal fade confirmation-popup" id="deletePop" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="confirmation-popup-icon">
                        <i>
                            <img src="@/assets/images/admin-img/light_delete-outline.svg" alt="" />
                        </i>
                    </div>
                    <div class="confirmation-popup-mid">
                        <p>{{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}</p>
                    </div>
                    <div class="confirmation-popup-btm">
                        <button id="popNoBtn" class="admin-btn-outline-secondary" data-bs-dismiss="modal">
                            {{ constants.NO_BUTTON }}
                        </button>
                        <button id="popYesBtn" class="admin-btn-outline-primary" data-bs-dismiss="modal" @click="confirmDelete">
                            {{ constants.YES_BUTTON }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts">
import { defineComponent, ref, nextTick } from 'vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import { CustomUploadAdapterPlugin } from '@/utils/CustomUploadAdapterPlugin';
import adminNavigation from "@/components/adminNavigation.vue";
import axios from 'axios';
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import Swal from 'sweetalert2';
import Datepicker from 'vue3-datepicker';
import SimpleBar from 'simplebar';
import moment from 'moment';
import { vBTooltip } from 'bootstrap-vue-3';
import Tooltip from 'bootstrap/js/dist/tooltip';
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';
import Sortable, { SortableEvent } from 'sortablejs';

interface Blog {
    id: number;
    title: string;
    description: string;
    author: string;
    blogCategory: string;
    location: string;
    blogImage: string;
    status: number;
    blogPostDate: string;
    editing?: boolean;
    Created_at?: string;
    relativePostDate?: string;
    position: number;
    slug: string;
}

interface BlogForm {
    title: string;
    description: string;
    author: string;
    blogCategory: string;
    location: string;
    blogImage: string;
    blogPostDate: Date;
    slug: string;
}

export default defineComponent({
    name: "Manage-Blog",
    directives: {
        'b-tooltip': vBTooltip
    },
    data() {
        return {
            constants,
            tooltips: [] as Tooltip[],
            blogCategories: [] as any,
            errMsg: '',
            errEditMsg: '',
            editor: ClassicEditor,
            activeTab: 'all',
            imageSrc: '',
            searchTempVar: '',
            editimageSrc: '',
            showAddForm: false,
            limit: 10,
            selectedFile: null as File | null,
            selectedEditFile: null as File | null,
            imageUploaded: false,
            selectAll: false,
            editFormSubmitted: false,
            blogs: [] as Blog[],
            editBlogsData: [] as Blog[],
            selectedBlogs: [] as string[],
            totalPages: 0,
            currentPage: 1,
            searchedText: '',
            counts: {
                all: 0,
                published: 0,
                unpublished: 0,
            } as any,
            editorConfig: {
            extraPlugins: [ this.customUploadAdapterPlugin ],
            toolbar: {
            items: [
            'heading', '|',
            'bold', 'italic','underline', 'link', 'bulletedList', 'numberedList', '|',
            'outdent', 'indent', '|',
            'imageUpload', '|',
            'undo', 'redo', '|',
            'insertTable',
            ]
            },
            image: {
            toolbar: ['imageTextAlternative', 'imageStyle:full', 'imageStyle:side']
            },
            },

            newBlog: {
                title: '',
                blogCategory: '',
                description: '',
                author: '',
                location: '',
                blogImage: '',
                blogPostDate: new Date(),
                slug: ''
            } as BlogForm,
            editBlogData: {
                title: '',
                blogCategory: '',
                description: '',
                author: '',
                location: '',
                blogImage: '',
                blogPostDate: new Date(),
                slug: ''
            } as BlogForm,
            blogToDelete: null as string | null,
            deleteMode: 'all' as 'all' | 'single',
            isSubmitting: false,
            isDragging: false,
            sortableInstance: null as Sortable | null,
            isNewSlugEditable: false,
            isEditSlugEditable: false,
            originalSlug: '' as string
        };
    },
    beforeRouteEnter(
        to: RouteLocationNormalized,
        from: RouteLocationNormalized,
        next: NavigationGuardNext
    ) {
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn !== "true") {
            next({ name: 'Login' });
        } else {
            next();
        }
    },
    computed: {

        Config(): any {
        return {
        extraPlugins: [CustomUploadAdapterPlugin],
        toolbar: {
        items: [
        'heading', '|',
        'bold', 'italic', 'link','underline', 'bulletedList', 'numberedList', '|',
        'outdent', 'indent', '|',
        'imageUpload', '|',
        'undo', 'redo', '|',
        'insertTable',
        ]
        },
        image: {
        toolbar: ['imageTextAlternative', 'imageStyle:full', 'imageStyle:side']
        }
        };
        },



        imageUrl(): string {
            return this.imageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
        editImage(): string {
            return this.editimageSrc || require('@/assets/images/admin-img/image-icon.svg');
        },
        visiblePages() {
            const maxVisiblePages = 5;
            const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
            let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
            let end = start + maxVisiblePages - 1;

            if (end > this.totalPages) {
                end = this.totalPages;
                start = Math.max(end - maxVisiblePages + 1, 1);
            }

            return Array.from({ length: end - start + 1 }, (_, i) => start + i);
        },
        disabledDatesObject() {
            return {
                predicate: (date: Date) => {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return date < today;
                }
            }
        }
    },
    components: {
        adminHeader,
        adminNavigation,
        Datepicker
    },
    created() {
        this.fetchCounts();
        this.fetchBlogs();
        this.getBlogCategories();
    },
    mounted() {
        const el = this.$refs.scrollWrapper as HTMLElement;
        if (el) {
            new SimpleBar(el);
        }
        this.initializeTooltips();
        this.setupSortable();
    },
    methods: {
        initializeTooltips() {
            const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            tooltipElements.forEach((element) => {
                const tooltip = new Tooltip(element);
                this.tooltips.push(tooltip);
            });
        },
        formatDate(date: any) {
            const pastDate = moment.utc(date).local();
            const now = moment();
            const secondsDiff = now.diff(pastDate, 'seconds');
            const minutesDiff = now.diff(pastDate, 'minutes');
            const hoursDiff = now.diff(pastDate, 'hours');
            const daysDiff = now.diff(pastDate, 'days');
            const weeksDiff = Math.floor(daysDiff / 7);
            const monthsDiff = now.diff(pastDate, 'months');
            const yearsDiff = now.diff(pastDate, 'years');

            if (secondsDiff < 60) {
                return `${secondsDiff} second${secondsDiff !== 1 ? 's' : ''} ago`;
            } else if (minutesDiff < 60) {
                return `${minutesDiff} minute${minutesDiff !== 1 ? 's' : ''} ago`;
            } else if (hoursDiff < 24) {
                return `${hoursDiff} hour${hoursDiff !== 1 ? 's' : ''} ago`;
            } else if (daysDiff < 7) {
                return `${daysDiff} day${daysDiff !== 1 ? 's' : ''} ago`;
            } else if (daysDiff < 30) {
                return `${weeksDiff} week${weeksDiff !== 1 ? 's' : ''} ago`;
            } else if (daysDiff < 365) {
                return `${monthsDiff} month${monthsDiff !== 1 ? 's' : ''} ago`;
            } else {
                return `${yearsDiff} year${yearsDiff !== 1 ? 's' : ''} ago`;
            }
        },
        setDeleteMode(mode: 'all' | 'single', blogSlug?: string) {
            this.deleteMode = mode;
            if (blogSlug !== undefined) {
                this.blogToDelete = blogSlug;
            }
        },
        confirmDelete() {
            if (this.deleteMode === 'all') {
                this.deleteSelectedContacts();
            } else if (this.deleteMode === 'single') {
                this.deleteBlog();
            }
        },
        changePage(page: number) {
            if (page > 0 && page <= this.totalPages) {
                this.currentPage = page;
                this.fetchBlogs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
                this.selectAll = false;
                this.selectedBlogs = [];
            }
        },
        openAddBlogForm() {
            this.resetForm();
            this.showAddForm = true;
            this.selectedBlogs = [];
            this.selectAll = false;
            this.cancelEdit();
            this.isNewSlugEditable = false;
        },
        handleFileUpload(event: any, isEdit: boolean = false) {
            const target = event.target as HTMLInputElement;
            if (target && target.files && target.files.length > 0) {
                const file = target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    if (e.target && typeof e.target.result === 'string') {
                        if (isEdit) {
                            this.editimageSrc = e.target.result;
                            this.selectedEditFile = file;
                        } else {
                            this.imageSrc = e.target.result;
                            this.selectedFile = file;
                            this.imageUploaded = true;
                        }
                    }
                };
            }
        },
        toggleBlogSelection(blogSlug: string) {
            if (this.selectedBlogs.includes(blogSlug)) {
                this.selectedBlogs = this.selectedBlogs.filter(id => id !== blogSlug);
            } else {
                this.selectedBlogs.push(blogSlug);
            }
        },
        toggleSelectAll() {
            if (this.selectAll === true) {
                this.selectedBlogs = [];
                this.selectAll = false;
            } else {
                this.selectedBlogs = this.editBlogsData.map(blog => blog.slug);
                this.selectAll = true;
            }
        },
        slugify(text: string): string {
            return text
                .toLowerCase()
                .trim()
                .replace(/\s+/g, '-')
                .replace(/^-|-$/g, '');
        },
        updateNewBlogSlug() {
            if (!this.isNewSlugEditable) {
                this.newBlog.slug = this.slugify(this.newBlog.title);
            }
        },
        updateEditBlogSlug() {
            if (!this.isEditSlugEditable) {
                this.editBlogData.slug = this.slugify(this.editBlogData.title);
            }
        },
        toggleNewSlugEdit() {
            this.isNewSlugEditable = !this.isNewSlugEditable;
            if (!this.isNewSlugEditable && !this.newBlog.slug) {
                this.newBlog.slug = this.slugify(this.newBlog.title);
            }
        },
        toggleEditSlugEdit() {
            this.isEditSlugEditable = !this.isEditSlugEditable;
            if (!this.isEditSlugEditable && !this.editBlogData.slug) {
                this.editBlogData.slug = this.slugify(this.editBlogData.title);
            }
        },
        async submitForm() {
            if (!this.newBlog.title || !this.newBlog.description || !this.newBlog.location ||
                !this.newBlog.author || !this.newBlog.blogCategory || !this.newBlog.blogPostDate ||
                !this.selectedFile || !this.newBlog.slug) {
                this.errMsg = "All Fields Are Required";
                return;
            }

            this.isSubmitting = true;

            const formData = new FormData();
            formData.append('title', this.newBlog.title);
            formData.append('description', this.newBlog.description);
            formData.append('author', this.newBlog.author);
            formData.append('blogCategory', this.newBlog.blogCategory);
            formData.append('slug', this.newBlog.slug);
            const selectedDate = new Date(this.newBlog.blogPostDate);
            const now = new Date();
            const hours = now.getHours();
            const minutes = now.getMinutes();
            const seconds = now.getSeconds();
            selectedDate.setHours(hours, minutes, seconds);
            formData.append('blogPostDate', selectedDate.toISOString());
            formData.append('location', this.newBlog.location);
            if (this.selectedFile) {
                formData.append('blogImage', this.selectedFile);
            }

            try {
                await axios.post(`${API_BASE_URL}/blog/`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                this.resetForm();
                await this.fetchCounts();
                if (this.counts[this.activeTab] > this.limit * this.currentPage) {
                    this.currentPage = Math.ceil(this.counts[this.activeTab] / this.limit);
                }
                await this.fetchBlogs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
                this.imageUploaded = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Blog Created Successfully!',
                    showConfirmButton: false,
                    timer: 1500
                });
            } catch (error: any) {
                console.error('Error submitting blog:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Failed to Create Blog',
                    text: error.response?.data?.detail || 'Please try again.',
                    showConfirmButton: true
                });
            } finally {
                this.isSubmitting = false;
            }
        },
        async deleteSelectedContacts() {
            try {
                await axios.delete(`${API_BASE_URL}/blog/bulk_delete/`, { data: { ids: this.selectedBlogs } });
                this.editBlogsData = this.editBlogsData.filter(blog => !this.selectedBlogs.includes(blog.slug));
                this.selectedBlogs = [];
                await this.fetchCounts();
                await this.fetchBlogs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
                if (this.editBlogsData.length === 0 && this.currentPage > 1) {
                    this.currentPage--;
                    await this.fetchBlogs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
                }
                this.selectAll = false;
                
            } catch (error: any) {
                console.error('Error deleting blogs:', error);
               
            }
        },
        async submitEditForm() {
            if (!this.editBlogData.title || !this.editBlogData.description ||
                !this.editBlogData.blogPostDate || !this.editBlogData.location ||
                !this.editBlogData.author || !this.editBlogData.blogCategory ||
                !this.editBlogData.slug) {
                this.errEditMsg = "All Fields Are Required";
                return;
            }

            this.isSubmitting = true;

            const formData = new FormData();
            formData.append('title', this.editBlogData.title);
            formData.append('description', this.editBlogData.description);
            formData.append('blogCategory', this.editBlogData.blogCategory);
            formData.append('author', this.editBlogData.author);
            formData.append('location', this.editBlogData.location);
            formData.append('slug', this.editBlogData.slug);
            const selectedDate = new Date(this.editBlogData.blogPostDate);
            const now = new Date();
            const hours = now.getHours();
            const minutes = now.getMinutes();
            const seconds = now.getSeconds();
            selectedDate.setHours(hours, minutes, seconds);
            formData.append('blogPostDate', selectedDate.toISOString());
            if (this.selectedEditFile) {
                formData.append('blogImage', this.selectedEditFile);
            }

            try {
                console.log('Submitting edit form for original slug:', this.originalSlug);
                console.log('FormData:', [...formData.entries()]);
                const response = await axios.patch(`${API_BASE_URL}/blog/${this.originalSlug}/`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                console.log('Edit response:', response.data);
                await this.fetchBlogs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
                this.cancelEdit();
                this.editFormSubmitted = false;
                Swal.fire({
                    icon: 'success',
                    title: 'Blog Updated Successfully!',
                    showConfirmButton: false,
                    timer: 1500
                });
            } catch (error: any) {
                console.error('Error updating blog:', error);
                console.log('Error response:', error.response?.data);
                Swal.fire({
                    icon: 'error',
                    title: 'Failed to Update Blog',
                    text: error.response?.data?.detail || JSON.stringify(error.response?.data) || 'Please try again.',
                    showConfirmButton: true
                });
            } finally {
                this.isSubmitting = false;
            }
        },
        handleLimitChange() {
            this.currentPage = 1;
            this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
            this.selectAll = false;
            this.selectedBlogs = [];
            this.fetchBlogs(this.activeTab, this.limit, 0);
        },
        async fetchBlogs(status = 'all', limit?: number, skip = 0, sortBy = 'position') {
  const effectiveLimit = limit ?? this.limit;

  let url = `${API_BASE_URL}/blog/`;
  const params = new URLSearchParams();
  if (status === 'published') params.append('status', '1');
  else if (status === 'unpublished') params.append('status', '0');

  if (this.searchedText && !this.searchTempVar) {
    this.currentPage = 1;
    this.searchTempVar = this.searchedText;
  }
  if (!this.searchedText && this.searchTempVar) {
    this.currentPage = 1;
    this.searchTempVar = '';
  }

  params.append('limit', effectiveLimit.toString());
  params.append('skip', skip.toString());
  if (this.searchedText) {
    params.append('searchedText', this.searchedText);
  }
  params.append('sort_by', sortBy);

  try {
    const response = await axios.get(`${url}?${params.toString()}`);
    this.editBlogsData = response.data.map((blog: { blogPostDate: moment.MomentInput }) => {
      return {
        ...blog,
        relativePostDate: moment(blog.blogPostDate).fromNow()
      };
    });
    // console.log('Fetched Blogs with Statuses:', this.editBlogsData.map(blog => ({ id: blog.id, slug: blog.slug, status: blog.status }))); // Log statuses
    this.totalPages = Math.ceil(this.counts[status] / effectiveLimit);
    // console.log('Blogs Fetched:', this.editBlogsData.length, 'Total Pages:', this.totalPages);
    this.setupSortable();
  } catch (error) {
    console.error('Error fetching blogs:', error);
  }
},
        async switchView(status: string) {
            this.currentPage = 1;
            this.activeTab = status;
            this.selectedBlogs = [];
            this.selectAll = false;
            this.editFormSubmitted = false;
            await this.fetchBlogs(status, this.limit, 0);
            if (status === 'published') {
                this.totalPages = Math.ceil(this.counts.published / this.limit);
            } else if (status === 'unpublished') {
                this.totalPages = Math.ceil(this.counts.unpublished / this.limit);
            } else {
                this.totalPages = Math.ceil(this.counts.all / this.limit);
            }
        },
        removeImage() {
            this.imageSrc = '';
            this.selectedFile = null;
            this.imageUploaded = false;
        },
        cancelForm() {
            this.newBlog = {
                title: '',
                blogCategory: '',
                description: '',
                author: '',
                location: '',
                blogImage: '',
                blogPostDate: new Date(),
                slug: ''
            } as BlogForm;
            this.selectedFile = null;
            this.imageSrc = '';
            this.showAddForm = false;
            this.imageUploaded = false;
            this.errMsg = '';
            this.isNewSlugEditable = false;
        },
        resetForm() {
            this.newBlog = {
                title: '',
                blogCategory: '',
                description: '',
                author: '',
                location: '',
                blogImage: '',
                blogPostDate: new Date(),
                slug: ''
            } as BlogForm;
            this.selectedFile = null;
            this.imageSrc = '';
            this.showAddForm = false;
            this.imageUploaded = false;
            this.errMsg = '';
            this.isNewSlugEditable = false;
        },
        async fetchCounts(searchedText?: string) {
            try {
                const baseUrl = `${API_BASE_URL}/blog/count/`;
                const queryParam = searchedText ? `?searchedText=${searchedText}&status=` : '?status=';

                const [allResponse, publishedResponse, unpublishedResponse] = await Promise.all([
                    axios.get(`${baseUrl}${queryParam}0&status=1`),
                    axios.get(`${baseUrl}${queryParam}1`),
                    axios.get(`${baseUrl}${queryParam}0`)
                ]);

                this.counts = {
                    all: allResponse.data.count,
                    published: publishedResponse.data.count,
                    unpublished: unpublishedResponse.data.count
                };

                if (this.activeTab in this.counts) {
                    this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
                    console.log('Counts:', this.counts, 'Total Pages:', this.totalPages, 'Limit:', this.limit);
                } else {
                    console.error(`Invalid active tab: ${this.activeTab}`);
                }
            } catch (error) {
                console.error('Error fetching blog counts:', error);
            }
        },
        editBlog(index: number) {
            this.editBlogsData.forEach((blog, i) => {
                blog.editing = i === index;
            });
            this.editFormSubmitted = true;
            const selectedBlog = this.editBlogsData[index];
            const blogPostDate = typeof selectedBlog.blogPostDate === 'string'
                ? new Date(selectedBlog.blogPostDate)
                : selectedBlog.blogPostDate;
            this.editBlogData = {
                title: selectedBlog.title,
                description: selectedBlog.description,
                author: selectedBlog.author,
                blogCategory: selectedBlog.blogCategory,
                location: selectedBlog.location,
                blogPostDate: blogPostDate,
                blogImage: selectedBlog.blogImage || '',
                slug: selectedBlog.slug
            };
            // Use getCdnImageAddress to ensure proper CDN URL
          this.editimageSrc = selectedBlog.blogImage
            ? this.getCdnImageAddress(selectedBlog.blogImage, 'w_200,h_100/')
              : '';
            this.originalSlug = selectedBlog.slug;
            this.isEditSlugEditable = false;
            if (this.sortableInstance) {
                this.sortableInstance.option('disabled', true);
            }
        },
        cancelEdit() {
            this.editBlogsData.forEach((blog) => {
                blog.editing = false;
            });
            this.editBlogData = {
                title: '',
                blogCategory: '',
                description: '',
                author: '',
                location: '',
                blogImage: '',
                blogPostDate: new Date(),
                slug: ''
            } as BlogForm;
            this.editFormSubmitted = false;
            this.selectedEditFile = null;
            this.editimageSrc = '';
            this.isEditSlugEditable = false;
            if (this.sortableInstance) {
                this.sortableInstance.option('disabled', false);
            }
        },
        async deleteBlog() {
            try {
                await axios.delete(`${API_BASE_URL}/blog/${this.blogToDelete}/`);
                await this.fetchCounts();
                await this.fetchBlogs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
                if (this.editBlogsData.length === 0 && this.currentPage > 1) {
                    this.currentPage--;
                    await this.fetchBlogs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
                }
                Swal.fire({
                    icon: 'success',
                    title: 'Blog Deleted Successfully!',
                    showConfirmButton: false,
                    timer: 1500
                });
            } catch (error: any) {
                console.error('Error deleting blog:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Failed to Delete Blog',
                    text: error.response?.data?.detail || 'Please try again.',
                    showConfirmButton: true
                });
            }
        },
        async changeBlogStatus(blogId: string, newStatus: number) {
    try {
        const formData = new FormData();
        formData.append('status', newStatus.toString());
        await axios.patch(`${API_BASE_URL}/blog/${blogId}/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        await this.fetchBlogs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        if (this.editBlogsData.length === 0 && this.currentPage > 1) {
            this.currentPage--;
            await this.fetchBlogs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
        }
        this.fetchCounts();
    } catch (error) {
        console.error('Error updating job status:', error);
    }
},
        async getBlogCategories() {
            try {
                const response = await axios.get(`${API_BASE_URL}/blogcategory/?status=1`);
                this.blogCategories = response.data;
            } catch (error) {
                console.error('Error fetching blog categories:', error);
            }
        },
        getCdnImageAddress(src: string, size: string): string {
            if (!src) return '';
            let cdnUrl: string = environment.imageCdn.getHost;
            cdnUrl = cdnUrl.concat(size);
            return cdnUrl + encodeURIComponent(src);
        },
        useStripHtml(html: string) {
            let regex = /(<([^>]+)>)/ig;
            return html.replace(regex, "");
        },
        setupSortable() {
            nextTick(() => {
                const sortableList = this.$refs.sortableList as HTMLElement;
                if (!sortableList) {
                    console.error('Sortable list ref not found!');
                    return;
                }

                if (this.sortableInstance) {
                    this.sortableInstance.destroy();
                }

                this.sortableInstance = Sortable.create(sortableList, {
                    animation: 150,
                    draggable: '.admin-item-box',
                    ghostClass: 'sortable-ghost',
                    chosenClass: 'sortable-chosen',
                    dragClass: 'sortable-drag',
                    filter: '.css-checkbox, button, input, select, textarea, a, .ck-editor, .ck-content',
                    preventOnFilter: true,
                    disabled: this.editFormSubmitted,
                    onStart: () => {
                        this.isDragging = true;
                    },
                    onEnd: async (evt: SortableEvent) => {
                        this.isDragging = false;
                        const oldIndex = evt.oldIndex!;
                        const newIndex = evt.newIndex!;

                        if (oldIndex === newIndex) return;

                        const newBlogsData = [...this.editBlogsData];
                        const [movedItem] = newBlogsData.splice(oldIndex, 1);
                        newBlogsData.splice(newIndex, 0, movedItem);

                        newBlogsData.forEach((item, index) => {
                            item.position = index + 1;
                        });

                        this.editBlogsData = newBlogsData;

                        const reorderedItems = newBlogsData.map((item) => ({
                            id: item.id,
                            position: item.position,
                        }));

                        try {
                            await axios.post(`${API_BASE_URL}/blog/reorder/`, {
                                items: reorderedItems,
                            });

                            await this.fetchBlogs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);

                            Swal.fire({
                                icon: 'success',
                                title: 'Order Updated Successfully!',
                                timer: 1500,
                                showConfirmButton: false,
                            });
                        } catch (error: any) {
                            console.error('Error updating order:', error);
                            await this.fetchBlogs(this.activeTab, this.limit, (this.currentPage - 1) * this.limit);
                            Swal.fire({
                                icon: 'error',
                                title: 'Order Update Failed!',
                                text: error.response?.data?.detail || 'Reverted to last saved order.',
                                showConfirmButton: false,
                                timer: 1500,
                            });
                        }
                    },
                });
            });
        }
    }
});
</script>

<style scoped>
.admin-item-box-top {
    cursor: move;
}
.admin-item-box.dragging {
    opacity: 0.5;
}
.slug-input-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
}
.slug-input-wrapper input {
    flex-grow: 1;
}
.edit-slug-btn {
    padding: 5px 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #f9f9f9;
    cursor: pointer;
}
.edit-slug-btn:hover {
    background-color: #e0e0e0;
}
</style>